import { schema, normalize } from 'normalizr';

const status = new schema.Entity('statuses');
const service = new schema.Entity('services', {
  statuses: [status],
});
const location = new schema.Entity('locations', {
  services: [service],
});

export default data => normalize(data, { locations: [location] });



// WEBPACK FOOTER //
// ./src/redux/dashboard/requests/filter-options-normalizer.js